/* Important Info component for the Locations Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/PostCreateEditForm.module.css";

const Important = () => {
  return (
    <div>
        <Row className="mb-3">
        <Col md={{span: 8, offset: 2}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={` pt-2`}>
          * Create a Location by adding the Location Name.
          </p>     
          <p className={`pt-2`}>
          * If a Location has <span className={`${styles.Red}`}>Sublocations</span> create a
          separate new Location for each.</p> 
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default Important